




































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import {Component, Vue} from 'vue-property-decorator';

import ContentSection from '@/components/ContentSection.vue';
import PricingPlans from '@/components/PricingPlans.vue';
import {gsap, Power3, ScrollTrigger} from '@/utils/gsap';
import {debounce} from '@/utils';
import checkIE from '@/utils/ie';

@Component({
	components: {
		'v-content-section': ContentSection,
		'v-pricing-plan': PricingPlans
	}
})
export default class Gold extends Vue {

	tl: any;

	cords: {
		screen: {
			width: number,
			height: number
		},
		carousel?: any,
		animationWrapper?: any
	} = {
		screen: {
			width: 0,
			height: 0
		},
		carousel: {
			top: 0
		},
		animationWrapper: {
			top: 0,
			left: 0
		}
	}

	isReset: boolean = false;

	html: any;
	cardRealCords: any = {};

	ultimateTimeline: any;

	ultimateCard: { width: number, height: number } = {
		width: 0,
		height: 0
	}

	sw: any = [];
	currentSlide: number = 0;
	anim: boolean = false;

	ease: string = 'back.inOut(1.7)';
	easeInOut: string = 'back.inOut(1.7)';
	animationsInited: boolean = false;

	isDirtyCard: boolean = false;

	$refs: {
		page: HTMLElement
		card: HTMLElement | any
		cardReal: HTMLElement
		cardContent: HTMLElement
		scroll: HTMLElement

		fixed: HTMLElement
		ultimateCard: HTMLElement

		carousel: HTMLElement
		sticky: HTMLElement
		carouselBG: HTMLElement
		animationWrapper: HTMLElement
		content: HTMLElement[]
		contentTrigger: HTMLElement[]

		visual: HTMLElement
		carouselVisual: HTMLElement[]
		carouselVisualWrapper: HTMLElement[]

		carouselVisualLive: HTMLElement
		carouselVisualTravel: HTMLElement
		carouselVisualPayments: HTMLElement
	}

	get isIE(): boolean {
		return checkIE();
	}

	get appModalName(): string {
		return this.$t('routes.getApp.modalName') as string;
	}

	get scrollDirection(): number {
		return this.$store.state.scrollToInfo.scrollDir;
	}

	async mounted(): Promise<void> {

		if (typeof window === 'undefined') {
			return;
		}

		this.ultimateCard = {
			width: window.innerWidth,
			height: window.innerHeight
		}

		this.html = document.querySelector('html');

		if (!this.html) {
			return;
		}

		this.ultimateTimeline = gsap.timeline({paused: true});

		await this.introAnimation();

		await this.introScroll();

		await this.resizeHandler();

		await window.addEventListener('resize', debounce(this.resizeHandler.bind(this), 100));
	}

	introAnimation(): void {

		this.tl = gsap.timeline({paused: true});

		this.html.classList.add('is-overflow-hidden');

		this.tl
			.addLabel('start')
			.fromTo(this.$refs.cardReal,
				{
					scale: 0,
					autoAlpha: 0,
					y: -this.$refs.cardReal.getBoundingClientRect().top
				},
				{
					duration: 0.7,
					delay: 0.5,
					scale: 1,
					autoAlpha: 1,
					y: 0,
					ease: this.easeInOut
				}
			)
			.to(this.$refs.cardContent,
				{
					autoAlpha: 1,
					duration: 0.6,
					scale: 1,
					ease: 'elastic.out(1, 0.3)'
				},
				'-=0.3'
			)
			.to(this.$refs.scroll,
				{
					autoAlpha: 1,
					y: 0,
					ease: Power3.easeInOut
				}
			)
			.add(() => {
				this.html.classList.remove('is-overflow-hidden');
			})
			.play();
	}

	initAnimations(): void {

		this.ultimateTimeline
			.to(this.$refs.carouselVisualLive, {
				autoAlpha: 1,
				scale: 1,
				ease: this.ease
			})
			.to(this.$refs.carouselVisualLive, {
				autoAlpha: 0,
				scale: 0,
				ease: this.ease
			})
			.to(this.$refs.carouselVisualTravel, {
				autoAlpha: 1,
				scale: 1,
				ease: this.ease
			})
			.to(this.$refs.carouselVisualTravel, {
					autoAlpha: 0,
					scale: 0,
					ease: this.ease
				}
			)
			.to(this.$refs.carouselVisualPayments, {
				autoAlpha: 1,
				scale: 1,
				ease: this.ease
			});
	}

	introScroll(): void {

		let sw = ScrollTrigger.create({
			trigger: this.$refs.carouselBG,
			scrub: 2,
			start: 'top top',
			end: `+=${this.$refs.carousel.offsetHeight} bottom`,
			pin: true,
			pinSpacing: false,
		});

		this.sw.push(sw);
	}

	handleMove(e: any): void {
		if (typeof window === 'undefined') {
			return;
		}

		const xVal = e.layerX
		const yVal = e.layerY

		const yRotation = (40 * ((xVal - this.ultimateCard.width / 2) / this.ultimateCard.width)).toFixed(2);
		const xRotation = (-40 * ((yVal - window.innerHeight / 2) / this.ultimateCard.height)).toFixed(2);

		if (!this.isReset) {
			gsap.set(this.$refs.card, {
				transition: ''
			})
		}

		this.isReset = true;

		gsap.set(this.$refs.card, {
			transformPerspective: 500,
			rotationX: xRotation,
			rotationY: yRotation,
			scale: 1.1
		});

	}

	handleMouseOut(): void {
		if (typeof window === 'undefined') {
			return;
		}

		gsap.set(this.$refs.card, {
			transition: 'all 0.3s ease-in-out'
		})

		gsap.set(this.$refs.card, {
			transformPerspective: 500,
			rotationX: 0,
			rotationY: 0,
			scale: 1
		});


		this.isReset = false;
	}

	handleMouseEnter(): void {
		if (typeof window === 'undefined') {
			return;
		}

		gsap.set(this.$refs.card, {
			transition: 'all 0.3s ease-in-out'
		})

		gsap.set(this.$refs.card, {
			transformPerspective: 0,
			rotationX: 0,
			rotationY: 0,
			scale: 1
		});


		this.isReset = false;
	}

	initScrollTrigger(): void {

		let sw = ScrollTrigger.create({
			trigger: this.$refs.carousel,
			animation: this.ultimateTimeline,
			start: 'top center',
			end: 'bottom bottom',
			scrub: 1
		});

		this.sw.push(sw);
	}

	stickyScroll(): void {

		if (!this.$refs.sticky) {
			return;
		}

		let sw = ScrollTrigger.create({
			trigger: this.$refs.sticky,
			start: 'top top',
			end: 'bottom bottom',
			pin: true,
			pinSpacing: false
		});

		this.sw.push(sw);
	}

	async resizeHandler(): Promise<void> {

		if (window.innerWidth > 767 && !this.animationsInited) {

			await this.initAnimations();

			if (this.isIE) {
				await this.stickyScroll();
			}

			await this.initScrollTrigger();

			this.animationsInited = true;
		}
	}

	beforeDestroy() {
		if (this.sw.length === null || typeof this.sw === 'undefined') {
			return;
		}

		this.sw.forEach((scrollTrigger: any) => scrollTrigger.kill());
	}

}
